import {
  Box,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomInput from "../../../Components/input/CustomInput";
import CustomButton from "../../../Components/Button/CustomButton";
import { handleSendNotification } from "../../../APIs/Function/Notification/SendNotification";
import { GetAllUser } from "../../../APIs/Function/User/GetAllUsers";
import * as Yup from "yup";

const Notification = () => {
  
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    type: "",
    ids: "",
  });

  const initialFormData = {
    title: "",
    message: "",
    type: "",
    ids: "",
  };

  const notificationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    message: Yup.string().required("Body text is required"),
    type: Yup.string().required("Send To is required"),
  });

  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendType, setSendType] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleTypeChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSendType(value);
  };

  const handleUser = async () => {
    try {
      setLoading(true);
      let res = await GetAllUser();
      setUserData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (event) => {
    try {
      await notificationSchema.validate(formData, { abortEarly: false });
      setLoading(true);
      
      if (formData.type === "1" && !formData.ids) {
        setLoading(false);
        alert("User is required when sending to a specific user");
        return;
      }
      const res = await handleSendNotification(formData);
      if (res.s) {
        setFormData({
          ...formData,
          message: "",
        });
        console.log(formData)
        setSendType("");
        setLoading(false);
        alert("Notification Send Successfully");
        window.location.reload();
      } else {
        console.log("error");
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errorMessages = error.errors.join("\n");
        alert(`${errorMessages}`);
      } else {
        console.error(error);
      }
    }
  };
  

  useEffect(() => {
    handleUser();
  }, []);

  return (
    <>
      <Box sx={{ p: 2, boxSizing: "border-box", width: "30%", height: "50%" }}>
        <Container maxWidth="sm" sx={{ mt: "20px" }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid sx={{ mt: "10px" }} item xs={12}>
                 <CustomInput
                  label="Notification Title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  fullWidth
                  required
                />
              </Grid>
              <Grid sx={{ mt: "10px" }} item xs={12}>
                <CustomInput
                  label="Body Text"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  fullWidth
                  multiline
                  rows={4}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel
                    sx={{
                      backgroundColor: "#FFF",
                    }}
                  >
                    Send To
                  </InputLabel>
                  <Select
                    name="type"
                    onChange={handleTypeChange}
                    sx={{ textAlign: "left" }}
                    value={sendType}
                  >
                    <MenuItem value="1">Select User</MenuItem>
                    <MenuItem value="2">Send To All Users</MenuItem>
                    <MenuItem value="3">Send To All Premium Users</MenuItem>
                    {/* <MenuItem value="4">Send To All Basic Users</MenuItem>/>   */}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel
                    sx={{
                      backgroundColor: "#FFF",
                      display: sendType === "1" ? "block" : "none",
                    }}
                  >
                    Select User
                  </InputLabel>
                  <Select
                    sx={{
                      display: sendType === "1" ? "block" : "none",
                      textAlign: "left",
                    }}
                    name="ids"
                    onChange={handleInputChange}
                  >
                    {userData?.map((e, i) => (
                      <MenuItem key={i} value={e.id}>
                        {e.full_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid sx={{ mt: "10px" }} item xs={12}>
                <CustomButton disabled={loading} onClick={handleSubmit}>Send</CustomButton>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Box>
    </>
  );
};

export default Notification;
